import React from 'react'
import PropTypes from 'prop-types'

import { specialAdCategories } from '../constants'

import { Card, Row, Col } from 'react-bootstrap'
import Input from '../../Shared/Input'
import KeyFactsForm from './KeyFactsFormPrisma'
import DropDown from 'components/Shared/DropDown'
import Textarea from 'components/Shared/Textarea'
import Switcher from './Switcher'
import { useTranslation } from 'react-i18next'
import useCustomTranslation from 'hooks/useCustomTranslation'
import { useLocation } from 'react-router-dom'

/**
 * Set simulation form with datapicker.
 * @Tags( simulation, api )
 * @Inputs( eventName, Date, Time, Venue, Hall, Capacity, Price, Artists, Tracks, Categories )
 * @NpmPackages( react-datepicker, date-fns )
 */
const SimulationFormPrisma = ({
  form,
  fields,
  onRemoveField,
  onUpdateInput,
  onUpdateDate,
  onCategoryChanged,
  onTabChanged,
  activeTab,
  onSpecialAdCategoryChanged,
}) => {
  const { t } = useTranslation()
  const location = useLocation()
  const { getTranslation } = useCustomTranslation()
  const isWave = location.state?.from === 'wave'
  const isSpecialTab = activeTab === 'special'
  
  return (
    <>
      <div className="simulation-form__section simulation-form__key-facts">
        <Card className="card-default mb-0">
          <Card.Body>
            <div className="simulation-form_header-wrap">
              <div className="requiredInputBox simulation-form_sim-name-wrap">
                <Input
                  placeholder={getTranslation('Simulation.form.eventName', isWave)}
                  separatePlaceholder={true}
                  value={form.simName}
                  name="name"
                  onChange={(e) => onUpdateInput(e)}
                  required
                />
              </div>

              <div className="simulation-form__tab-category-wrap">
                <Switcher selectedOption={activeTab} setSelectedOption={onTabChanged} onCategoryChanged={onCategoryChanged} />
              
                {isSpecialTab && (
                  <DropDown
                    onChange={(value) => onSpecialAdCategoryChanged(value)}
                    value={form.specialAdCategory}
                    options={specialAdCategories.map(category => ({
                      value: category.value,
                      text: t('Simulation.form.specialAdCategories.' + category.value),
                    })).sort((a, b) => a.text.localeCompare(b.text))}
                    placeholder={t('Simulation.form.specialAdCategory')}
                    classNames="simulation-form_sim-category-dropdown mb-3"
                  />
                )}
              </div>
            </div>

            <div className="requiredInputBox">
              <Textarea
                classNames="mb-0 mt-3 mt-md-0"
                placeholder={getTranslation('Simulation.form.description', isWave)}
                separatePlaceholder
                value={form.description ?? ''}
                name="description"
                onChange={(e) => onUpdateInput(e)}
                maxLength={2500}
                showMax
                rows={5}
                required
              />
            </div>

            <div>
              <Row className="mt-3">
                <Col sm={12} md={5} lg={4} className="mb-3 mb-md-0">
                  <KeyFactsForm
                    key={`f-${0}`}
                    startDate={form.startDate}
                    updateDate={onUpdateDate}
                    fields={fields[0]}
                    updateInput={onUpdateInput}
                    index={0}
                    removeField={onRemoveField}
                  />
                </Col>
              </Row>
            </div>
          </Card.Body>
        </Card>
      </div>
    </>
  )
}

SimulationFormPrisma.propTypes = {
  form: PropTypes.object,
  fields: PropTypes.array,
  onAddField: PropTypes.func,
  onRemoveField: PropTypes.func,
  onUpdateInput: PropTypes.func,
  onUpdateDate: PropTypes.func,
  onCategoryChanged: PropTypes.func,
  onTabChanged: PropTypes.func,
  activeTab: PropTypes.string,
  onSpecialAdCategoryChanged: PropTypes.func,
}

export default SimulationFormPrisma
